export function isWeekBreakNestingValidationError(error) {
    const message = error?.response?.data?.message ?? '';

    return error?.response?.status === 422 && message.includes('Week and Break sections cannot be nested');
}

/** Reorder failures that show dedicated course-editor toasts instead of AutoSave snackbars. */
export function isReorderStructuralValidationError(error) {
    return isWeekBreakNestingValidationError(error);
}
